import type { HttpTransport } from '@mangovoice/api-client'

/**
 * PBX Locations resource - delegates to the @mangovoice/pbx-locations-ui library
 * for actual endpoint definitions. This provides a pass-through transport adapter.
 */
export function createPbxLocationsResource(transport: HttpTransport) {
  return {
    get: <T>(url: string, params?: Record<string, unknown>) =>
      transport.get<T>(url, params),

    post: <T>(url: string, data?: unknown) => transport.post<T>(url, data),

    patch: <T>(url: string, data?: unknown) => transport.patch<T>(url, data),

    delete: <T>(url: string, params?: Record<string, unknown>) =>
      transport.delete<T>(url, params),
  }
}
